import type { AgreementStates, Agreements } from "../types";

// Drop "hidden" channels from the agreements payload so we never record
// consent the user couldn't see. The marketing checkbox in the UI is
// hardcoded to `acceptMarketingPhoneContact` and also syncs `acceptNewsletter`
// in onChange — so a config like `marketingPhoneContact: "hidden"` +
// `newsletter: "required"` would otherwise leak `acceptMarketingPhoneContact:
// true` into the API. The UI mismatch is intentional (single generic marketing
// checkbox) until backend/distribution config catches up; this filter is the
// data-side guard for that interim state.
export const buildAgreementsPayload = (formValues: Agreements, agreementStates: AgreementStates): Agreements => {
  const result: Agreements = {
    acceptDataProcessing: formValues.acceptDataProcessing,
    acceptTouNPp: formValues.acceptTouNPp,
  };
  if (agreementStates.acceptGroupAction !== "hidden") {
    result.acceptGroupAction = formValues.acceptGroupAction;
  }
  if (agreementStates.newsletter !== "hidden") {
    result.acceptNewsletter = formValues.acceptNewsletter;
  }
  if (agreementStates.marketingPhoneContact !== "hidden") {
    result.acceptMarketingPhoneContact = formValues.acceptMarketingPhoneContact;
  }
  return result;
};
